const ChatItemListSkeleton = () => {
  return (
    <>
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className="flex items-center gap-[12px] px-[20px] py-[12px]">
          <div className="flex-none">
            <div className="w-[46px] h-[46px] rounded-full bg-gray-100 dark:bg-gray-800 animate-pulse" />
          </div>

          <div className="flex flex-col gap-[4px] items-start w-full">
            <div className="flex justify-between w-full">
              <div className="w-[100px] h-[20px] rounded bg-gray-100 dark:bg-gray-800 animate-pulse" />
              <div className="w-[40px] h-[13px] rounded bg-gray-100 dark:bg-gray-800 animate-pulse" />
            </div>

            <div className="flex justify-between w-full">
              <div className="w-[150px] h-[16px] rounded bg-gray-100 dark:bg-gray-800 animate-pulse" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ChatItemListSkeleton;
